import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import _ from 'lodash';

const Wrapper = styled.div``;

const InnerWrapper = styled.div`
  flex: 1;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  box-sizing: border-box;
`;

const TableHeader = styled.div`
  display: flex;
  background-color: #fbfbfb;
  align-items: center;
  border-bottom: 1px solid #e8e9ea;
`;

const Body = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;

const Row = styled.div`
  background-color: #fff;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  position: relative;
  transition: box-shadow 2s ease-in-out;
  border: 1px solid;
  border-color: #e8e9ea;
  margin-top: -1px;
  transition: border-color 0.2s ease-in-out;

  &:nth-of-type(2n) {
    background-color: #fbfbfb;
  }

  div {
    font-weight: 400;
  }
`;

const Title = styled.div`
  flex: 1;
  color: #41474f;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 15px;
  padding: 9px 12px;
  box-sizing: border-box;
`;

const QtyTitle = styled.div`
  width: 116px;
  text-align: center;
  color: #41474f;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 15px;
  padding: 9px 8px;
  box-sizing: border-box;
`;

const Product = styled.div`
  flex: 1;
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.24px;
  color: #1c232c;
  line-height: 20px;
  box-sizing: border-box;
  word-break: break-word;
`;

const Quantity = styled.div`
  padding: 7px 4px;
  width: 116px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  border-left: 1px solid;
  border-color: #e8e9ea;
  position: relative;
  color: #1c232c;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  transition: border-color 0.2s ease-in-out;
`;

interface Props {
  headers: string[];
  events: any[];
}

const ReportTable: React.FunctionComponent<Props> = ({ headers, events }) => {
  const expandEvent = (event: any): string[] => {
    const { action, id, client, deviceId } = event;
    return [action, id?.substr(0, 8) || '', client, deviceId];
  };

  return (
    <Wrapper>
      <InnerWrapper>
        <TableHeader>
          {headers.map((header, i) => {
            if (headers.length - 1 !== i) {
              return <Title key={header}>{header}</Title>;
            }
            return <QtyTitle key={header}>{header}</QtyTitle>;
          })}
        </TableHeader>
        <Body>
          {events.map((event) => (
            <Row key={event.eventId}>
              {expandEvent(event).map((cell, i) => (
                <Product key={event.eventId + i}>{cell}</Product>
              ))}
              <Quantity>{moment(event.sentAt).format('MM/DD HH:mm')}</Quantity>
            </Row>
          ))}
        </Body>
      </InnerWrapper>
    </Wrapper>
  );
};

export default ReportTable;
